import React, {useMemo} from 'react';
import { PageDialogContent, PageDialogFooter } from '../../components/dialog';
import { useForm, useWatch } from 'react-hook-form';
import { BtnComponent } from '../../components/button';
import { DatePickerFeild } from "../../components/reactHookFormFields/datePicker";
import moment from 'moment';
import {imageFromUuid, isPatientChatMessage, printMessage} from "../../helpers/utility";
import { useGroupChatContext } from "../../context/groupchatContext";
import { chatApi } from '../../services/chatService';


const PrintMessage = ({cancelPrintPopup}) => {

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const watchedFromDate = useWatch({ control, name: 'from_date' });
    const watchedToDate = useWatch({ control, name: 'to_date' });

    const groupChatContext = useGroupChatContext();
    const { selectedChat } = useMemo(() => ({
        selectedChat: groupChatContext.selectedChat,
    }));

    const [getPrintChatUuid, {isLoading: isPrintChatUuidLoading}] = chatApi.endpoints.getPrintChatUuid.useLazyQuery();

    const onSubmitForm = async(value) => {
        const payload = {
            start_date: value?.from_date ? moment(value?.from_date).format('YYYY-MM-DD') : '',
            end_date: value?.to_date ? moment(value?.to_date).format('YYYY-MM-DD') : '',
        }

        
        if(isPatientChatMessage(selectedChat)){
            payload.pid = selectedChat.pid;
        }
        else {
            payload.location_id = selectedChat.location_id;
        }

        const response = await getPrintChatUuid(payload);
        if(response?.data?.uuid){
            const url = imageFromUuid(response.data.uuid);
            window.open(url, "_blank");
            cancelPrintPopup();
        }
    }
    return (
        <>
            <PageDialogContent contentCls="p-3 sm:p-4 md:px-6">
                <form id="print_message_form" onSubmit={handleSubmit(onSubmitForm)} className="min-w-0">
                    <div className="pt-4 pb-2 sticky top-[-10px] bg-white z-30">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 pb-3">
                            <div className="min-w-0">
                                <DatePickerFeild
                                    title="From Date"
                                    control={control}
                                    name="from_date"
                                    dateTime={false}
                                    maxDate={watchedToDate || new Date()}
                                    rules={{
                                        required: watchedToDate ? false : { value: true },
                                    }}
                                    errors={errors}
                                />
                            </div>
                            <div className="min-w-0 relative z-[0]">
                                <DatePickerFeild
                                    title="To Date"
                                    control={control}
                                    name="to_date"
                                    dateTime={false}
                                    rules={{
                                        required: watchedFromDate ? false : { value: true },
                                    }}
                                    errors={errors}
                                    minDate={watchedFromDate}
                                    maxDate={new Date()}
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </PageDialogContent>
            <PageDialogFooter>
                <BtnComponent text="Cancel" btnType="default" onClick={cancelPrintPopup} />
                <BtnComponent text="Print" loading={isPrintChatUuidLoading} btnType='primary_theme' 
                 form="print_message_form" type="submit" />
            </PageDialogFooter>
        </>
    );
    
};

export default PrintMessage;